// FPS History tracker, optimized for per-frame sampling and secondarily for finding the median
// Internally this uses an array indexed by fps
export default class FPSHistory {
    constructor(minFPS, maxFPS) {

        this.minFPS = minFPS;
        this.maxFPS = maxFPS;

        // Median data
        this.totalSamples = 0;
        this.data = new Array(maxFPS - minFPS + 1);
        for (var i = 0; i < this.data.length; i++) {
            this.data[i] = 0;
        }

        // Running average data
        this.runningAverage = 0;
        this.totalAverageSamples = 0;

    }

    // Calculate index to data array from integer fps value
    getIndex(fps) {
        return Math.max(this.minFPS, Math.min(this.maxFPS, fps - this.minFPS));
    }

    // Add a single integer fps sample to the data
    sample(fps) {
        // Update median data
        this.data[this.getIndex(fps)]++;
        this.totalSamples++;

        // Update running average data
        if (this.totalAverageSamples <= 0) {
            this.runningAverage = fps;
            this.totalAverageSamples = 1;
            return;
        }


        const totalSamplesPlusOne = this.totalAverageSamples + 1;

        this.runningAverage = 
            (this.totalAverageSamples / totalSamplesPlusOne) * this.runningAverage
            +
            (1 / totalSamplesPlusOne) * fps;
        
        this.totalAverageSamples = totalSamplesPlusOne;

    }

    // Return the median fps of the data set
    median() {
        const medianSampleNumber = Math.ceil(this.totalSamples / 2);
        var sum = 0;
        for (var i = 0; i < this.data.length; i++) {
            sum += this.data[i];
            if (sum >= medianSampleNumber)
                return i;
        }
    }

    avg() {
        return this.runningAverage;
    }

    resetAvg() {
        this.runningAverage = 0;
        this.totalAverageSamples = 0;
    }

    getAverageSamples() {
        return this.totalAverageSamples;
    }

    stdDeviation() {
        const average = this.avg();

        // Calculate the numerator of the std. deviation formula
        const sum = this.data.reduce((accumulator, nItemsInBucket, index) => {
            // Calculate what FPS this bucket's "label" is
            const bucketFPS  = index + this.minFPS;

            var difference_squared = (bucketFPS - average) * (bucketFPS - average) * nItemsInBucket;

            return accumulator + difference_squared;
        }, 0);

        // Divide by number of items in the sample and sqrt
        return Math.sqrt(sum / this.totalSamples);
    }
}